import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { pageTransitions } from '../../../animations/page-transitions';
import { DynamicDatacenterFilter, GlobalSearchFilter } from '../../../models/datacenter-filters';

@Component({
	selector: 'copo-global-search-filter',
	templateUrl: './global-search-filter.component.html',
	styleUrl: './global-search-filter.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, MatFormFieldModule, MatInputModule, FormsModule]
})
export class GlobalSearchFilterComponent implements DynamicDatacenterFilter<GlobalSearchFilter> {
	@Input() filter?: GlobalSearchFilter;
	@Input() isDefaultFilter?: boolean;
	@Output() readonly removeFilter = new EventEmitter<void>();

	removeValue(index: number) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(index, 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return { id: this.filter.filterId, values: this.filter.getValues().filter(filterValue => !filterValue) };
		}
		return undefined;
	}
}
